import React from 'react';

export function shortenAtlasId(companyId, basic=false) {
  const text = companyId.match(/..-/) ? companyId.replace(/control_room/g, 'cr').replace(/bureau/g, 'bu') : companyId;
  if (basic) {
    return text;
  }
  return (
    <a href={`https://companies.permaconn.com/company/${companyId}`} target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  );
}
